import { render, staticRenderFns } from "./Flitter.vue?vue&type=template&id=2391b896&scoped=true&"
import script from "./Flitter.vue?vue&type=script&lang=js&"
export * from "./Flitter.vue?vue&type=script&lang=js&"
import style0 from "./Flitter.vue?vue&type=style&index=0&id=2391b896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2391b896",
  null
  
)

export default component.exports